import { $selectedBunkers, bunkersInitialState, setSelectedBunkers } from '@/modules/mixing/store/selected-bunkers.store';
import { useStore } from 'effector-react';
import { useState } from 'react';



export const useBunkers = () => {
  const bunkers = useStore($selectedBunkers);
  const setBunkers = setSelectedBunkers;
  //const [bunkers, setBunkers] = useState(bunkersInitialState);

  const addSingleSectionItem = () => {
    const newState = { ...bunkers };
    newState.singleSection.push(bunkersInitialState.singleSection[0]);
    setBunkers(newState);
  };

  const addMultiSectionItem = () => {
    const newState = { ...bunkers };
    newState.multiSection.push(bunkersInitialState.multiSection[0]);
    setBunkers(newState);
  };

  const removeSingleSectionItem = (idx: number) => {
    const filteredList = [
      ...bunkers.singleSection.slice(0, idx),
      ...bunkers.singleSection.slice(idx + 1),
    ];
    setBunkers({ ...bunkers, singleSection: filteredList });
  };

  const removeMultiSectionItem = (idx: number) => {
    const filteredList = [
      ...bunkers.multiSection.slice(0, idx),
      ...bunkers.multiSection.slice(idx + 1),
    ];
    setBunkers({ ...bunkers, multiSection: filteredList });
  };

  const setMultiSectionItemValue = ({
    label,
    id,
    itemIdx,
    i,
  }: {
    label: string;
    id: number;
    itemIdx: number;
    i: number;
  }) => {
      const multiSection = [...bunkers.multiSection];
      const items = [...multiSection[itemIdx].items];
      items[i] = { id, label };
      multiSection[itemIdx] = { items };
      return setBunkers({ ...bunkers, multiSection });
  };

  const setSingleSectionItemValue = ({
    label,
    id,
    itemIdx,
  }: {
    label: string;
    id: number;
    itemIdx: number;
  }) => {
    const singleSectionCopy = [...bunkers.singleSection];
  singleSectionCopy[itemIdx] = { id, label };
  setBunkers({ ...bunkers, singleSection: singleSectionCopy });
  };

  const setInitialState = () => {
    setBunkers({...bunkersInitialState});
  };

  return {
    totalState: bunkers,
    addSingleSectionItem,
    addMultiSectionItem,
    removeSingleSectionItem,
    removeMultiSectionItem,
    setMultiSectionItemValue,
    setSingleSectionItemValue,
    setInitialState,
  };
};


